module.exports = __webpack_public_path__ + "src/assets/img/m42.41fd1258.svg";